export const AUTH_CONFIG = {
    domain: 'login.peptalkr.com.au',
    clientID: 'yZwj8giSYMutLGDVKBevX1aF7adyhBx7',
    devRedirectUri: 'https://localhost:44390',
    stagingRedirectUri: 'https://stagingdash.peptalkr.com.au',
    redirectUri: 'https://dashboard.peptalkr.com.au',
    startSession: '/startSession',
    audience: 'https://api.peptalkr.com'
};


// WEBPACK FOOTER //
// ./src/Auth0Config.js